import { curry2 } from '@most/prelude';
export var complete = curry2(function complete(value, subject) {
    return subject.complete(value);
});
//# sourceMappingURL=complete.js.map


//////////////////
// WEBPACK FOOTER
// ./~/most-subject/lib/es2015/combinators/complete.js
// module id = 1594
// module chunks = 0